import { useEffect } from "react";
import { loadAssignmentProgress } from "../utils/assignments/loadAssignmentProgress";

const useTestHydration = ({
  user,
  packet,
  questions,
  setAnswers,
  setMarked,
  setCurrentIndex,
  setQuestionTimes,
  setTimeRemaining,
  setIsHydrated,
  setMode,
}) => {
  useEffect(() => {
    let isMounted = true;

    async function hydrate() {
      if (!user || !packet || questions.length === 0) return;

      const saved = await loadAssignmentProgress({
        studentUid: user.uid,
        packetId: packet.id,
      });

      if (!isMounted) return;

      setMode(saved?.status ?? "in_progress");

      if (saved?.totalTimeSpentSeconds != null) {
        const totalSeconds = packet.estimatedMinutes * 60;
        const remaining = Math.max(
          totalSeconds - saved.totalTimeSpentSeconds,
          0
        );
        setTimeRemaining(remaining);
      }

      if (saved?.questionProgress) {
        const nextAnswers = questions.map(
          (q) => saved.questionProgress[q.id]?.answer ?? null
        );

        const nextMarked = questions.map(
          (q) => !!saved.questionProgress[q.id]?.marked
        );

        const nextTimes = Object.fromEntries(
          questions.map((q) => [
            q.id,
            saved.questionProgress[q.id]?.timeSpentSeconds ?? 0,
          ])
        );

        setAnswers(nextAnswers);
        setMarked(nextMarked);

        if (saved?.status === "completed" || saved?.status === "review") {
          setCurrentIndex(0);
        } else {
          setCurrentIndex(saved.currentQuestionIndex ?? 0);
        }

        setQuestionTimes(nextTimes);
      } else {
        setAnswers(Array(questions.length).fill(null));
        setMarked(Array(questions.length).fill(false));
      }

      setIsHydrated(true);
    }

    hydrate();
    return () => {
      isMounted = false;
    };
  }, [
    user,
    packet,
    questions,
    setAnswers,
    setMarked,
    setCurrentIndex,
    setQuestionTimes,
    setTimeRemaining,
    setIsHydrated,
  ]);
};

export default useTestHydration;
